/* Componente per la creazione delle icone per i mezzi */
import React from 'react';
import DirectionsBus from '@material-ui/icons/DirectionsBus';
import TrainIcon from '@material-ui/icons/Train';
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat';
import FlightIcon from '@material-ui/icons/Flight';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';

export default class RenderMezzi extends React.Component {
 
        showArrow = (index,tot) => {
            if ((index + 1) < tot){
                return <ArrowForwardIosRoundedIcon className={"imageArrow"} style={{fontSize:'12px'}}/>
            }
        }

        switchMezziImage = (mode, color,route,index,tot) => {
            
            switch (mode){
                case 'WALK':
                    return (<div className={'listaRoute'}> 
                                    <DirectionsWalkIcon style={{fontSize:'17px'}}/>
                                    {this.showArrow(index,tot)}
                            </div>);
                case 'BUS':
                    return (<div className={'listaRoute'} >
                                        <DirectionsBus style={{fontSize:'20px',color: 'gray'}}/>
                                        <div className={"routeTesto"} style={{backgroundColor: '#007ac9'}}> {route} </div> 
                                        {this.showArrow(index,tot)} 
                            </div>);
                case 'CAR':
                    return (<div className={'listaRoute'}> 
                                    <DirectionsCarIcon style={{fontSize:'17px'}}/>
                                    {this.showArrow(index,tot)}
                            </div>);
                case 'RAIL':
                    return (<div className={'listaRoute'} >
                                        <TrainIcon style={{fontSize:'20px',color: 'gray'}}/>
                                        <div className={"routeTesto"} style={{backgroundColor: '#a30b01'}}> {route} </div> 
                                        {this.showArrow(index,tot)} 
                            </div>);

                case 'TRAM':
                    return (<div className={'listaRoute'} >
                                        <TrainIcon style={{fontSize:'20px',color: 'gray'}}/>
                                        <div className={"routeTesto"} style={{backgroundColor: '#00985f' }}> {route} </div> 
                                        {this.showArrow(index,tot)} 
                            </div>);

                case 'SUBWAY':
                    return (<div className={'listaRoute'} >
                                        <TrainIcon style={{fontSize:'20px',color: 'gray'}}/>
                                        <div className={"routeTesto"} style={{backgroundColor: '#00985f'}}> {route} </div> 
                                        {this.showArrow(index,tot)} 
                            </div>);
                case 'FUNICULAR':
                    return (<div className={'listaRoute'} >
                                        <TrainIcon style={{fontSize:'20px',color: 'gray'}}/>
                                        <div className={"routeTesto"} style={{backgroundColor: '#00985f'}}> {route} </div> 
                                        {this.showArrow(index,tot)} 
                            </div>);              
                 case 'GONDOLA':
                    return (<div className={'listaRoute'} >
                                        <TrainIcon style={{fontSize:'20px',color: 'gray'}}/>
                                        <div className={"routeTesto"} style={{backgroundColor: '#00985f'}}> {route} </div> 
                                        {this.showArrow(index,tot)} 
                            </div>);
                case 'BICYCLE':
                    return (<div className={'listaRoute'} >
                                        <DirectionsBikeIcon style={{fontSize:'20px',color: 'gray'}}/>
                                        {this.showArrow(index,tot)} 
                            </div>);
                case 'FERRY':
                    return (<div className={'listaRoute'} >
                                        <DirectionsBoatIcon style={{fontSize:'20px',color: 'gray'}}/>
                                        <div className={"routeTesto"} style={{backgroundColor: '#00b9e4'}}> {route} </div> 
                                        {this.showArrow(index,tot)} 
                            </div>);
                case 'AIRPLANE':
                    return (<div className={'listaRoute'} >
                                        <FlightIcon style={{fontSize:'20px',color: 'gray'}}/>
                                        <div className={"routeTesto"} style={{backgroundColor: '#12b08b'}}> {route} </div> 
                                        {this.showArrow(index,tot)} 
                            </div>);

                default:
                    return (<div className={'listaRoute'} >
                                        <TrainIcon style={{fontSize:'20px',color: 'gray'}}/>
                                        <div className={"routeTesto"} style={{backgroundColor: '#' + color}}> {route} </div> 
                                        {this.showArrow(index,tot)} 
                            </div>);
            }
        }
        render(){
            const {data, index, tot} = this.props
            
            return (
                this.switchMezziImage(data.mode, data.routeColor,data.route,index,tot)
            )
        }

}

